import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function (hero) {
	const planet = hero.querySelector('.planet-2');

	// --hero-progress turns the blue planet round its orbit (services.css): from the left at the top of the page to the bottom, over the intro, as it comes up.
	gsap.fromTo(planet, { '--hero-progress': 0 }, {
		'--hero-progress': 1,
		ease: 'none',
		scrollTrigger: {
			start: 0,
			// Until the hero's bottom reaches 70% of the screen, and over at least a third of a screen: on phones it starts almost there.
			end: () => Math.max(window.innerHeight * 0.35, hero.getBoundingClientRect().bottom + window.scrollY - window.innerHeight * 0.7),
			invalidateOnRefresh: true,
			scrub: true,
		},
	});
}
